// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2tjbW","title":"AfterFrontImage_title__3Bt_6"};